
import Vue from 'vue'
import { mapGetters } from 'vuex'
import loadLine from './../loadLine/index.vue'
import { ILevel, VerificationStatuses } from './../../../../types'

const defaultLevelData: ILevel = {
  status: VerificationStatuses.notStarted,
  reason: null
}

export default Vue.extend({
  name: 'kyc-extended',
  data () {
    return {
      openedPanel: null as number | null
    }
  },
  props: {
    levelData: {
      type: Object,
      required: true,
      default: () => defaultLevelData
    }
  },
  mounted () {
    this.openedPanel = this.levelData.status === 'accepted' ? 1 : 0
  },
  computed: {
    ...mapGetters('user', ['getUserData'])
  },
  methods: {
    proceedVerification () {
      this.$emit('proceedVerification')
    }
  },
  components: { loadLine }
})
